import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import componentBase from '../../../../src/lib/component-base';
import FSFlatButton from '../../../../src/components/lib/FSFlatButton';
import DropDownMenu from '../../../../src/components/lib/FSDropDownMenu';
import onResize from '../../../../src/lib/on-resize';
import { regions, regionText } from '../regions';

const ZoomButton = props => (
  <FSFlatButton
    label={props.label}
    onClick={props.zoomTo(props.region)}
    style={{ width: '14%' }}
    backgroundColor={props.region === props.activeRegion ? '#81A2CA' : '#003259'}
    labelStyle={{
      textTransform: 'none',
      fontSize: '11px',
      padding: '1px',
    }}
  />
);
ZoomButton.propTypes = {
  label: PropTypes.node,
  zoomTo: PropTypes.func,
  region: PropTypes.string,
  activeRegion: PropTypes.string,
};

const ResponsiveDropDown = props => (
  <DropDownMenu
    className='delay-map-dropdown'
    value={props.value}
    onChange={props.clickHandler}
    autoWidth={false}
  >
    {props.children}
  </DropDownMenu>
);
ResponsiveDropDown.propTypes = {
  value: PropTypes.number,
  autoWidth: PropTypes.func,
  clickHandler: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.node),
};

@onResize()
@componentBase('AirportDelayMapZoomControl')
export default class AirportDelayMapZoomControl extends React.Component {
  static propTypes = {
    zoomTo: PropTypes.func,
    region: PropTypes.string,
  };
  static defaultProps = { region: 'northAmerica' }

  constructor(props) {
    super(props);
    this.state = {
      value: regions.indexOf(props.region),
    };
  }

  componentDidMount() {
    this.initResizeListener();
  }

  componentWillUnmount() {
    this.removeResizeListener();
  }

  handleResize = () => this.forceUpdate();

  handleChange = (event, index, value) => this.setState({ value });

  renderMenuItems = callback => (
    regions.map((region, index) => (
      <MenuItem
        key={`select-${region}`}
        value={index}
        primaryText={`View ${regionText[index]}`}
        onClick={callback(region)}
      />))
  );

  render() {
    // this.logger(this.mediaBreakpoint);
    if (this.mediaBreakpoint) {
      if (this.mediaBreakpoint.name !== 'desktopLg') {
        return (
          <div className='responsive-dropdown-container'>
            <ResponsiveDropDown value={this.state.value} clickHandler={this.handleChange.bind(this)}>
              {this.renderMenuItems(this.props.zoomTo)}
            </ResponsiveDropDown>
          </div>
        );
      }
    }
    return (
      <div className='region-buttons'>
        <ZoomButton label='North America' region='northAmerica' activeRegion={this.props.region} zoomTo={this.props.zoomTo} />
        <ZoomButton label='Europe' region='europe' activeRegion={this.props.region} zoomTo={this.props.zoomTo} />
        <ZoomButton label='Asia' region='asia' activeRegion={this.props.region} zoomTo={this.props.zoomTo} />
        <ZoomButton label='Oceania' region='oceania' activeRegion={this.props.region} zoomTo={this.props.zoomTo} />
        <ZoomButton label='Africa' region='africa' activeRegion={this.props.region} zoomTo={this.props.zoomTo} />
        <ZoomButton label='South America' region='southAmerica' activeRegion={this.props.region} zoomTo={this.props.zoomTo} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/AirportDelayMap/components/children/AirportDelayMapZoomControl.js